import React from 'react';
import { Trans } from 'react-i18next';

import { Select, CounterLabel } from '@weezevent/nacre';

import css from '../../conditions.module.css';

const PREFIX = 'ticket.moderation.statusesTransitions.conditions.detail.conditionRules.delay';

const OPTIONS = [
    { text: <Trans i18nKey={`${PREFIX}.hours`} />, value: 3600 },
    { text: <Trans i18nKey={`${PREFIX}.minutes`} />, value: 60 },
    { text: <Trans i18nKey={`${PREFIX}.seconds`} />, value: 1 }
];

const DelayCondition = ({ condition, handleCondition }) => {
    const [unit, setUnit] = React.useState(3600);

    return (
        <div className={css['conditions-card-container']}>
            <div className={css['delay-input']}>
                <CounterLabel min={1} step={1} value={condition.delay / unit} onChange={(_, value) => handleCondition('delay', value * unit)} />
            </div>
            <div className={css['delay-input']}>
                <Select useNew value={unit} options={OPTIONS} onChange={value => setUnit(value)} />
            </div>
        </div>
    );
};

export default DelayCondition;
